import React from 'react'
import Column from '@components/column'
import {
  StyleImage,
  StyleImageGrid,
  StyleImageWrapper,
  StylePermission,
  StylePermissionGrid,
} from '@commons/user-detail-modal/style'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import {
  bookingsmanagement,
  routesetupsvg,
  schedulemanagementsvg,
  switchOff,
  switchOn,
  vehiclemanagementsvg,
} from '@assets/icons'
import Svg from '@components/svg'
import Typography from '@components/typography'
import Row from '@components/row'
import styled from '@emotion/styled'

const FallbackAvatar = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
`

const UserDetailModal = ({ item }) => {
  const [initialValues] = React.useState({
    name: item.name,
    number: item.phoneNo,
  })
  const userPermissions: string[] = item?.permissions?.permissions ?? []
  const Permissions = [
    { icon: routesetupsvg, name: 'Route Setup' },
    { icon: vehiclemanagementsvg, name: 'Vehicle Management' },
    { icon: schedulemanagementsvg, name: 'Schedule Management' },
    { icon: bookingsmanagement, name: 'Booking Management' },
  ]

  const firstInitial = item?.name ? item.name.charAt(0) : '?'

  return (
    <Column>
      <StyleImageGrid>
        <StyleImageWrapper>
          {item.avatar ? (
            <StyleImage src={`${process.env.APP_BUCKET_URL}/${item.avatar}`} />
          ) : (
            <FallbackAvatar>{firstInitial}</FallbackAvatar>
          )}
        </StyleImageWrapper>
      </StyleImageGrid>

      <Formik initialValues={initialValues} onSubmit={(values) => {}}>
        <Form>
          <Column>
            <Fields.Input name={'name'} label={'Full Name'} />
            <Fields.Input name={'number'} label={'Mobile Number'} />
          </Column>
        </Form>
      </Formik>

      <Typography size={14}>Permission Module</Typography>
      {!!item?.permissions && (
        <StylePermissionGrid>
          {Permissions.map((perm, idx) => {
            const isSelected = userPermissions.includes(perm.name)
            return (
              <StylePermission key={idx} selected={isSelected}>
                <Svg src={perm.icon} />
                <Typography size={14} color={isSelected && 'primary'}>
                  {perm.name}
                </Typography>
              </StylePermission>
            )
          })}
        </StylePermissionGrid>
      )}

      <Row styleRow={'justify-content:space-between'}>
        <Typography>Set Team Status as Active</Typography>
        <Svg src={item.isActive ? switchOn : switchOff} />
      </Row>
    </Column>
  )
}

export default UserDetailModal
